import React from 'react';
import {
  confirm_close,
  confirm_extendStr,
  Default_confirmation_screen,
  getSubCategoryId,
  Recipient_details_open,
} from '../../../utils/DictionaryManagementUtils';
import ConfirmTransferFP from '../FullPagesComponents/Services/Confirmation/ConfirmTransferFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

const ConfirmationDF = ({
  globJSON,
  blueStr,
  selectedScreen,
  simPlatform,
  showOnlyFirstPage,
  withOutIconLine,
  withOutLink,
  stringButtom,
  isConfirmation_split,
  withOutTopTitle,
  slideshowRefs,
  isLoan,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const confirmation = globJSON.configurations.services[subCategoryId].confirmation || globJSON.configurations.services[subCategoryId].confirmation_split;
  const { enable_transaction_fee_on_the_recipient } = isConfirmation_split ? false : confirmation;
  //= ====================================================================

  return (
    <SimulatorsViewerArrangement>
      <ConfirmTransferFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        confirmation={confirmation}
        subCategoryId={subCategoryId}
        headlineText={isLoan ? confirmation.confirm_loan_details : confirmation.does_it_look_ok}
        withoutIconLine={withOutIconLine || !enable_transaction_fee_on_the_recipient}
        TopTitle={Default_confirmation_screen}
        withOutLink={withOutLink}
        stringBottom={stringButtom}
        isConfirmation_split={isConfirmation_split}
        withOutTopTitle={withOutTopTitle}
        blueStr={blueStr}
        slideshowRefs={slideshowRefs}
        isLoan={isLoan}
      />
      {!showOnlyFirstPage
            && (
            <ConfirmTransferFP
              globJSON={globJSON}
              simPlatform={simPlatform}
              confirmation={confirmation}
              subCategoryId={subCategoryId}
              headlineText={confirmation.does_it_look_ok}
              withoutIconLine={!enable_transaction_fee_on_the_recipient}
              blueStr={confirm_close}
              extendStrings={confirm_extendStr}
              TopTitle={Recipient_details_open}
              stringBottom={stringButtom}
              withOutTopTitle={withOutTopTitle}
              slideshowRefs={slideshowRefs}
              isLoan={isLoan}
            />
            )}
    </SimulatorsViewerArrangement>
  );
};

export default ConfirmationDF;
